import React from 'react';
import { useMedia } from 'react-media';

import queries from 'utils/media-queries';
import HeaderDesktop from './header-desktop';
import HeaderMobile from './header-mobile';

import './style.css';

const Header = () => {
  const matches = useMedia({ queries });
  return matches.small ? <HeaderMobile /> : <HeaderDesktop />;
};

export default Header;
